import { OrderReviewRating } from '../types';

export const ORDER_REVIEW_COMMENT_MAX_LENGTH = 500;
export const ORDER_REVIEW_PICKUP_HIDDEN_COMPLAINT_VALUES = ['damaged_by_post'];

export const ORDER_REVIEW_RATING_OPTIONS: Array<{
    value: OrderReviewRating;
    label: string;
}> = [
    { value: 'very_good', label: 'Дуже добре' },
    { value: 'good', label: 'Добре' },
    { value: 'neutral', label: 'Нейтрально' },
    { value: 'bad', label: 'Погано' },
    { value: 'very_bad', label: 'Дуже погано' },
];

export const ORDER_REVIEW_COMPLAINT_OPTIONS = [
    {
        value: 'no_reply_to_messages',
        label: 'Не відповідав на повідомлення',
    },
    {
        value: 'item_in_wrong_language',
        label: 'Товар не тією мовою',
    },
    {
        value: 'items_were_missing',
        label: 'Не вистачало частини товарів',
    },
    {
        value: 'damaged_by_post',
        label: 'Пошкоджено під час доставки',
    },
    {
        value: 'wrong_version_of_item',
        label: 'Неправильна версія товару',
    },
    {
        value: 'incorrect_card_grading',
        label: 'Некоректний стан або грейд',
    },
];

export const ORDER_REVIEW_RATING_LABELS = Object.fromEntries(
    ORDER_REVIEW_RATING_OPTIONS.map((option) => [option.value, option.label]),
) as Record<OrderReviewRating, string>;

export const ORDER_REVIEW_COMPLAINT_LABELS = Object.fromEntries(
    ORDER_REVIEW_COMPLAINT_OPTIONS.map((option) => [
        option.value,
        option.label,
    ]),
) as Record<string, string>;

export const getOrderReviewRatingLabel = (
    rating?: OrderReviewRating | null,
): string => {
    if (!rating) return 'Не вказано';

    return ORDER_REVIEW_RATING_LABELS[rating] || 'Не вказано';
};

export const getOrderReviewComplaintLabel = (
    complaint: string,
): string | null => ORDER_REVIEW_COMPLAINT_LABELS[complaint] || null;
